// extracted by mini-css-extract-plugin
module.exports = {"container":"Chat--AssetLink-module_container-FPYfP","name":"Chat--AssetLink-module_name-1gbJ5"};